export default __webpack_public_path__ + "static/media/materialui.a2deaf3c.png";